import { URL } from ".";
import fetchApi from "../util/fetchApi";

export default class UserService {
  async getUser(id) {
    return (await fetchApi.get(`${URL}/user/${id}`)).data;
  }

  async getAllUsers({ search, limit, page, orderBy, order, Status, Role }) {
    return (
      await fetchApi.get(
        `${URL}/user/list?limit=${limit}&page=${page}&orderBy=${orderBy}&order=${order}&Status=${Status}&Role=${Role}${
          search ? `&search=${encodeURIComponent(search)}` : ""
        }`
      )
    ).data;
  }

  async getEmployees() {
    return (await fetchApi.get(`${URL}/user/list?Role=2`)).data;
  }

  async getCustomers() {
    return (await fetchApi.get(`${URL}/user/list?Role=3`)).data;
  }

  async getSuppliers() {
    return (await fetchApi.get(`${URL}/user/list?Role=4`)).data;
  }

  async getUserRoles() {
    return (await fetchApi.get(`${URL}/user/userroles`)).data;
  }

  async createUser(formData) {
    return (await fetchApi.post(`${URL}/user`, formData)).data;
  }

  async updateUser(id, formData) {
    return (await fetchApi.patch(`${URL}/user/${id}`, formData)).data;
  }

  async updatePassword(id, formData) {
    return (await fetchApi.patch(`${URL}/user/password/${id}`, formData)).data;
  }

  async deleteUser(id) {
    return (await fetchApi.delete(`${URL}/user/${id}`)).data;
  }
}
